// extracted by mini-css-extract-plugin
export default {"input-field":"Inputs_input-field__5J3pV","form__inputs-group":"Inputs_form__inputs-group__ZQNVZ"};